module.exports = __webpack_public_path__ + "img/anitras dance.9fda1362.png";